import {SHIPMENT_BY_ACCOUNT_NUMBER_SERVICE_ERROR, RESET_SHIPMENT_BY_ACCOUNT_NUMBER_SERVICE_ERROR} from "../actions/shipmentDataByAccountNumberActions";

const initialState = {
  serviceError: false
};

export default function (state = initialState, action) {

  switch (action.type) {
    case SHIPMENT_BY_ACCOUNT_NUMBER_SERVICE_ERROR:
      return {
        ...state,
        serviceError: true
      };
    case RESET_SHIPMENT_BY_ACCOUNT_NUMBER_SERVICE_ERROR:
      return {
        ...state,
        serviceError: false
      };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/shipmentByAccountNumberReducer.js